import { queryOptions } from '@tanstack/react-query'

import { MINUTE } from '@/core/constants/constants'

import { createApiMethod, type } from './utils/createApiMethod'

export type Department = {
  id: string
  name: string
}

export type DepartmentList = {
  departments: Department[]
}

export const companyDepartments = {
  list: createApiMethod({
    method: 'GET',
    path: '/company/departments',
    response: type<DepartmentList>(),
  }),

  create: createApiMethod({
    method: 'POST',
    path: '/company/departments',
    data: type<{ name: string }>(),
  }),

  update: createApiMethod({
    method: 'PUT',
    path: '/company/departments/:id',
    data: type<{ name: string }>(),
  }),

  delete: createApiMethod({
    method: 'DELETE',
    path: '/company/departments/:id',
  }),
}

export const companyDepartmentsQueries = {
  all: () => ['company-departments'] as const,
  list: () =>
    queryOptions({
      queryKey: [...companyDepartmentsQueries.all(), 'list'] as const,
      queryFn: () => companyDepartments.list(),
      staleTime: MINUTE * 10,
    }),
}
